import { render } from "./BaseIconText.vue?vue&type=template&id=40cada8a&scoped=true"
import script from "./BaseIconText.vue?vue&type=script&lang=js"
export * from "./BaseIconText.vue?vue&type=script&lang=js"

import "./BaseIconText.vue?vue&type=style&index=0&id=40cada8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40cada8a"]])

export default __exports__